import React, { useRef, useCallback } from 'react';
import { Box, Paper, Typography, Stack, IconButton, Tooltip, useTheme } from '@mui/material';
import { Panel, PanelGroup, PanelResizeHandle } from 'react-resizable-panels';
import MonacoEditor from '../../components/MonacoEditor';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ClearIcon from '@mui/icons-material/Clear';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import ToolPageContainer from '../../components/ToolPageContainer';

function ConverterLayout({
  title,
  description,
  leftTitle,
  rightTitle,
  leftLanguage,
  rightLanguage,
  leftValue,
  setLeftValue,
  rightValue,
  onConvert,
  onSwap,
  onClear,
}) {
  const theme = useTheme();
  const leftEditorRef = useRef(null);
  const rightEditorRef = useRef(null);

  const handleResize = useCallback(() => {
    setTimeout(() => {
      leftEditorRef.current?.layout();
      rightEditorRef.current?.layout();
    }, 0);
  }, []);

  const handleCopy = () => {
    navigator.clipboard.writeText(rightValue);
  };

  return (
    <ToolPageContainer title={title} description={description} disablePadding>
      <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 2 }}>
        <PanelGroup direction="horizontal" onLayout={handleResize}>
        <Panel>
          <Paper sx={{ p: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Typography variant="subtitle1" sx={{ mb: 1, textAlign: 'center' }}>{leftTitle}</Typography>
            <Box sx={{ flexGrow: 1, border: `1px solid ${theme.palette.divider}`, borderRadius: 1 }}>
              <MonacoEditor ref={leftEditorRef} language={leftLanguage} value={leftValue} onChange={setLeftValue} />
            </Box>
          </Paper>
        </Panel>
        <PanelResizeHandle style={{ width: '20px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Stack spacing={1}>
            <Tooltip title="Convert">
              <IconButton onClick={onConvert} color="primary" sx={{ border: `1px solid ${theme.palette.divider}` }}>
                <PlayArrowIcon />
              </IconButton>
            </Tooltip>
            {onSwap && (
              <Tooltip title="Swap">
                <IconButton onClick={onSwap} sx={{ border: `1px solid ${theme.palette.divider}` }}>
                  <SwapHorizIcon />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </PanelResizeHandle>
        <Panel>
          <Paper sx={{ p: 1, height: '100%', display: 'flex', flexDirection: 'column' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
              <Typography variant="subtitle1" sx={{ textAlign: 'center', flexGrow: 1 }}>{rightTitle}</Typography>
              <Tooltip title="Copy Output">
                <IconButton onClick={handleCopy} size="small">
                  <ContentCopyIcon fontSize="small" />
                </IconButton>
              </Tooltip>
              <Tooltip title="Clear All">
                <IconButton onClick={onClear} size="small">
                  <ClearIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Stack>
            <Box sx={{ flexGrow: 1, border: `1px solid ${theme.palette.divider}`, borderRadius: 1 }}>
              <MonacoEditor ref={rightEditorRef} language={rightLanguage} value={rightValue} options={{ readOnly: true }} />
            </Box>
          </Paper>
        </Panel>
      </PanelGroup>
      </Box>
    </ToolPageContainer>
  );
}

export default ConverterLayout;
